import { date2usDotDateTime } from "helpers";
import React from "react";

import styles from './DateTimeSelect.module.scss';

interface IDateTimeSelect {
  value: string;
  setValue: (value: string) => void;
}

const DateTimeSelect = ({ value, setValue }: IDateTimeSelect) => {
  const timeInputRef = React.useRef<HTMLInputElement>(null);

  return (
    <>
      <p
        className={styles.timeText}
        // onClick={() => timeInputRef.current?.showPicker()}
      >
        {value ? date2usDotDateTime(value) : 'Click to Select'}
      </p>
      <input
        ref={timeInputRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={{ opacity: 0, height: 0, margin: 0, padding: 0 }}
        type="datetime-local"
      />
    </>
  )
}

export default DateTimeSelect